<template>
    <div class="contact">
        <Commondtitle title="联系我们" />
        <div class="con_map">
            <div class="con_m_des">
                <div class="con_m_d_item">
                    <i class="icon_feiji"></i>
                    <p>乘坐<span>102路</span>(民航机场-国际商贸城客运 中心)民航机场站上车到<span>曹道站下车</span></p>
                </div>
                <div class="con_m_d_item">
                    <i class="icon_huoche"></i>
                    <p>乘坐<span>义乌b支803路</span>(火车站-龙回枢纽)火车站站上车-到<span>行政五号楼站下车</span></p>
                </div>
                <hr>
                <div class="con_m_d_item con_hr_bottom">
                    <i class="iconfont iconshouji"></i>
                    <span>{{ companyobj.fphone }}</span>
                </div>
                <div class="con_m_d_item con_hr_bottom">
                    <i class="iconfont iconemail-s"></i>
                    <span>{{ companyobj.femail }}</span>
                </div>
                <div class="con_m_d_item con_hr_bottom">
                    <i class="iconfont icondingwei003"></i>
                    <span>{{ companyobj.faddress }}</span>
                </div>
            </div>
        </div>
        <Commondtitle v-if="workArr.length !== 0" title="加入我们" />
        <div v-if="workArr.length !== 0" class="con_clllapse">
            <el-collapse accordion v-model="activeName">
                <el-collapse-item
                        v-for="(item,index) in workArr"
                        :key="index"
                        :name="index">
                    <template slot="title">
                        <div class="con_c_div">
                            <h4 class="con_c_title">{{ item.fhiring }}</h4>
                            <p class="con_c_des">工作地点：{{item.fworkAddress}} | 工作年限：{{item.fworkYears}}年 | 学历：{{ item.feducationBackground }}</p>
                        </div>
                    </template>
                    <div class="con_c_content">
                        <div class="con_c_c_left">
                            <h6>岗位职责：</h6>
                            <ul>
                                <li
                                    :key="idx"
                                    v-for="(tag,idx) in item.fresponsibilitiesList">
                                    {{ tag }}</li>
                            </ul>
                        </div>
                        <div class="con_c_c_left">
                            <h6>任职要求：</h6>
                            <ul>
                                <li
                                    :key="idx"
                                    v-for="(tag,idx) in item.fjobRequirementsList"
                                >{{ tag }}</li>
                            </ul>
                        </div>
                    </div>
                </el-collapse-item>
                <!-- 模板
                <el-collapse-item name="1">
                    <template slot="title">
                        <div class="con_c_div">
                            <h4 class="con_c_title">IOS开发工程师</h4>
                            <p class="con_c_des">工作地点：义乌 | 工作年限：3年 | 学历：大专及以上</p>
                        </div>
                    </template>
                    <div class="con_c_content">
                        <div class="con_c_c_left">
                            <h6>岗位职责：</h6>
                            <ul>
                                <li>1、根据产品的需求进行iOS项目的开发、上架、维护；</li>
                                <li>2、基于公司的产品设计进行iOS版本应用的实现；</li>
                                <li>3、跟进iOS的新技术发展，编写设计开发及实现文档；</li>
                            </ul>
                        </div>
                        <div class="con_c_c_left">
                            <h6>任职要求：</h6>
                            <ul>
                                <li>1、全日制专科及以上学历，计算机相关专业，2年以上IOS开发经验；</li>
                                <li>2、熟悉iOS应用开发框架，能独立开发iOS应用，并具有1年以上的相关项目经验；</li>
                                <li>3、熟练掌握Objective-C，熟悉MacOS，Xcode及iPhone SDK开发环境，良好的编程习惯； </li>
                                <li>4、熟悉.net语言，熟练使用sql server数据库； </li>
                                <li>5、至少参加过一个完整的商业级手机应用开发项目，有移动开发项目经验者优先；</li>
                                <li>6、可独立承担开发任务，对项目进行需求分析设计，并能够撰写项目文档；</li>
                            </ul>
                        </div>
                    </div>
                </el-collapse-item>-->

            </el-collapse>
        </div>
    </div>
</template>

<script>
    import Commondtitle from '../Commondtitle'
    import axios from '../../assets/js/baseaxios'
    export default {
        name: "contact",
        data(){
            return{
                activeName: 0,
                workArr: [],
                companyobj:{}
            }
        },
        mounted(){
            this.getData()
        },
        methods:{
            getData(){
                axios.get(`/api/recruitment?page=1&limit=20`).then(res=>{
                    if(res.data.success){
                        let items = res.data.items
                        if(items.length === 0)return
                        this.workArr = items
                    }else{
                        this.$message.warning(res.data.msg)
                    }
                })
                axios.get(`/api/company`).then(res=>{
                    if(res.data.success){
                        this.companyobj = res.data.items[0]
                    }else{
                        this.$message.warning(res.data.msg)
                    }
                })
            }
        },
        components:{
            Commondtitle
        }
    }
</script>

<style scoped>
.contact{
    width: 100%;
}
    .con_map{
        width: 1100px;
        height: 500px;
        margin: 0 auto;
        position: relative;
        margin-bottom: 40px;
        background: url("../../assets/images/map.png") center/cover no-repeat;
    }
    .con_map .con_m_des{
        position: absolute;
        top: 84px;
        right: 26px;
        width: 280px;
        padding: 30px 20px;
        box-sizing: border-box;
        background-color: #fff;
    }
    .con_map .con_m_des .con_m_d_item{
        height: 32px;
        margin-bottom: 30px;
    }
    .con_m_d_item i{
        float: left;
        display: block;
        width: 24px;
        height: 32px;
        margin-right: 11px;
    }
    .con_m_d_item i.icon_feiji{
        background: url("../../assets/images/icon-feiji.png") no-repeat center/24px 32px;
    }
    .con_m_d_item i.icon_huoche{
        background: url("../../assets/images/icon-huoche.png") no-repeat center/24px 32px;
    }
    .con_m_d_item p{
        float: left;
        width: 200px;
        line-height: 16px;
        font-size: 12px;
        color: #999;
    }
    .con_m_d_item p span{
        color: #00B76B;
    }
    .con_m_des hr{
        margin-bottom: 30px;
        color: #E5E5E5;
    }
    .con_map .con_m_des .con_m_d_item.con_hr_bottom{
        font-size: 14px;
        color: #999;
        line-height: 19px;
        margin-bottom: 10px;
    }
    .con_hr_bottom i{
        font-size: 20px;
        color: #00B76B;
    }
    .con_clllapse{
        width: 1100px;
        margin: 0 auto 100px;
    }
    .con_clllapse .con_c_div{
        padding-left: 30px;
    }
    .con_clllapse .con_c_title{
        line-height: 24px;
        color: #fff;
        font-size: 18px;
        font-weight: 700;
        margin-bottom: 10px;
    }
     .con_clllapse .con_c_des{
        line-height: 16px;
         color: #fff;
         font-size: 12px;
     }
    .con_c_content{
        display: flex;
        justify-content: space-between;
        padding:20px 20px 25px 30px;
    }
    .con_c_content .con_c_c_left{
        width: 480px;
    }
    .con_c_c_left h6{
        font-size: 14px;
        color: #333;
        line-height: 19px;
        margin-bottom: 20px;
    }
    .con_c_c_left ul li{
        color: #666;
        font-size: 14px;
        line-height: 19px;
    }
</style>